import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a6d2c06c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a6d2c06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d2c06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d2c06c')) {
      api.createRecord('a6d2c06c', component.options)
    } else {
      api.reload('a6d2c06c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a6d2c06c&scoped=true&", function () {
      api.rerender('a6d2c06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QEot06hkMm3Y/JS/comp/PopupBox.vue"
export default component.exports